import IProductDatabase from './IProductDatabase';
import ITopicBase from './ITopicBase';
import ITopic from './ITopic';
import IProductBase from './IProductBase';
import IProductClass from './IProductClass';
import IProduct from './IProduct';
import VideoFile from './VideoFile';
import _ from 'lodash';

//const LOREM_DESC = 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.' +
//  ' Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.';

const P_DROP300 = { id: 1, name: 'Tasty Drops - 300mg CBD', priceInCents: 5000, image: 'Tasty-Drops.png', description:
  'Tasty Drops is a hemp oil tincture formulated with full-spectrum phytocannabinoids (CBD, CBDa) for a stronger than ' +
  'ever concentration. Enhanced with synergistic terpenes from various plants such as hemp and clary sage. ' +
  'Available in Spearmint, Berry, and Natural.' };
const P_DRP1000 = { id: 2, name: 'Tasty Drops - 1000mg CBD', priceInCents: 9999, image: 'Tasty-Drops.png', description:
  'Tasty Drops is a hemp oil tincture formulated with full-spectrum phytocannabinoids (CBD, CBDa) for a stronger than ' +
  'ever concentration. Enhanced with synergistic terpenes from various plants such as hemp and clary sage. ' +
  'Available in Spearmint, Berry, and Natural.' };
const P_GUMMIES = { id: 3, name: 'Tasty Gummies', priceInCents: 9999, image: 'Gummies-40ct.jpg', description:
  'Enjoy a daily serving of CBD in the form of CBD gummies! These tasty gummy bears come in an assortment of fruit flavors ' +
  'and are an enjoyable part of your nutritional routine. The Tasty Hemp Oil gummies contain 25mg of CBD per gummy and are ' +
  'flavored naturally.' +
  'Qty: 40 gummies per bottle, 25mg in each bear.' };
const P_GMYSMPL = { id: 4, name: 'Tasty Gummies - Sample', priceInCents: 1200, image: 'Gummies-4ct.jpg', description:
  'Enjoy a daily serving of CBD in the form of CBD gummies! These tasty gummy bears come in an assortment of fruit flavors ' +
  'and are an enjoyable part of your nutritional routine. The Tasty Hemp Oil gummies contain 25mg of CBD per gummy and are ' +
  'flavored naturally.' +
  'Qty: 4 gummies per sample bag, 25mg in each bear.' };
const P_SALV150 = { id: 5, name: 'CBD Salve - 150mg', priceInCents: 3900, image: 'CBD-Salve-150mg.jpg', description:
  'CBD Salve is an effective way to soothe sore muscles and joints. Containing 150mg CBD, this all-natural salve uses ' +
  'the power of cannabidiol or CBD hemp oil to relieve physical stressors. An additional 10+ plant extracts, including ' +
  'violet leaf and basil, work together for an overall powerful product.' };
const P_SALV500 = { id: 6, name: 'CBD Salve - 500mg', priceInCents: 5800, image: 'CBD-Salve-500mg.jpg', description:
  'CBD Salve supports your skin with 100% natural and organic food-grade ingredients. Apply this CBD salve topically ' +
  'and allow it to absorb directly into the skin, providing relief from irritation and dryness. This soothing skincare ' +
  'product can be used anywhere on the body, including the face and neck. This CBD product contains 500mg CBD.' };
const P_CAPSL15 = { id: 7, name: 'CBD Softgels - 15mg', priceInCents: 5900, image: 'tasty-hemp-oil-softgels.jpg', description:
  'The Tasty Hemp Oil CBD Softgels are loaded with a full-spectrum hemp oil extract that contains natural phytocannabinoids ' +
  'and terpenes. Each softgel contains 15mg cannabidiol (CBD). With 30 softgels per bottle, that’s a total of 450mg CBD per bottle.' };
const P_CAPSL50 = { id: 8, name: 'CBD Softgels - 50mg', priceInCents: 10500, image: 'CBD-gelcaps-50mg.jpg', description:
  'The Tasty Hemp Oil CBD Softgels are loaded with a full-spectrum hemp oil extract that contains natural phytocannabinoids ' +
  'and terpenes. Each softgel contains 50mg cannabidiol (CBD). With 30 softgels per bottle, that’s a total of 1500mg CBD per bottle.' };

const PC_DROPS = { id: 101, name: 'Tasty Drops', products: [1, 2], image: 'Tasty-Drops.png' };
const PC_GUMMY = { id: 102, name: 'Tasty Gummies', products: [3, 4], image: 'Gummies-40ct.jpg' };
const PC_SALVE = { id: 103, name: 'CBD Salve', products: [5, 6], image: 'CBD-Salve-500mg.jpg' };
const PC_CAPSL = { id: 104, name: 'CBD Softgels', products: [7, 8], image: 'CBD-gelcaps-50mg.jpg' };


// const P_SALVE   = { id: 1, name: 'Abinoid CBD Salve', priceInCents: 3595, image: 'abinoid-cbd-salve.jpg', description: LOREM_DESC };
// const P_GUMMIES = { id: 2, name: 'Tasty Hemp Gummies', priceInCents: 9999, image: 'tasty-hemp-gummies.jpg', description: LOREM_DESC };
// const P_SOFTGEL = { id: 3, name: 'Tasty Hemp Oil Softgels 30-pack', priceInCents: 5995, image: 'tasty-hemp-oil-softgels.jpg', description: LOREM_DESC };
// const P_OILDROP = { id: 4, name: 'Tasty Hemp Oil Drops - 300mg CBD', priceInCents: 5995, image: 'tasty-hemp-oil-drops.jpg', description: LOREM_DESC };
// const P_BATHBOM = { id: 5, name: 'CBD Bath Bomb', priceInCents: 1495, image: 'cbd-bath-bomb.jpg', description: LOREM_DESC };
// const P_FACESER = { id: 6, name: 'Abinoid Face Serum', priceInCents: 4235, image: 'abinoid-face-serum.jpg', description: LOREM_DESC };
// const P_FACETON = { id: 7, name: 'Abinoid Face Toner', priceInCents: 2499, image: 'abinoid-face-toner.jpg', description: LOREM_DESC };
// const P_FACECLE = { id: 8, name: 'Abinoid Face Cleanser', priceInCents: 2700, image: 'abinoid-face-cleanser.jpg', description: LOREM_DESC };
// const P_HEMPEXT = { id: 9, name: 'Proprietary Hemp Extract', priceInCents: 4995, image: 'proprietary-hemp-extract.jpg', description: LOREM_DESC };
// const P_BATHSOA = { id: 10, name: 'CBD Living Bath Soap', priceInCents: 1495, image: 'cbd-living-soap.jpg', description: LOREM_DESC };
// const P_OILCARE = { id: 11, name: 'Hemp Oil Care', priceInCents: 8150, image: 'hemp-oil-care.jpg', description: LOREM_DESC };
// const P_ISOLATE = { id: 12, name: 'CBD Isolate', priceInCents: 5640, image: 'cbd-isolate.jpg', description: LOREM_DESC };
// const P_FREEZE  = { id: 13, name: 'CBD Freeze', priceInCents: 3595, image: 'cbd-freeze.jpg', description: LOREM_DESC };

const HOW_JOINT = { mp4: '01-how-cbd-can-help-with-joint-pain.mp4', vtt: '01-how-cbd-can-help-with-joint-pain.vtt', title: 'How CBD Can Help With Joint Pain'};
const HOW_ANXIE = { mp4: '02-how-cbd-can-help-with-anxiety.mp4', vtt: '02-how-cbd-can-help-with-anxiety.vtt', title: 'How CBD Can Help With Anxiety'};
//const HOW_DEPRE = { mp4: '03-how-cbd-can-help-with-depression.mp4', vtt: '03-how-cbd-can-help-with-depression.vtt', title: 'How CBD Can Help With Depression'};
const HOW_PAIN  = { mp4: '04-how-cbd-can-help-with-pain.mp4', vtt: '04-how-cbd-can-help-with-pain.vtt', title: 'How CBD Can Help Pain'};
const HOW_FOCUS = { mp4: '05-how-cbd-can-help-with-focus.mp4', vtt: '05-how-cbd-can-help-with-focus.vtt', title: 'How CBD Can Help With Focus'};
//const HOW_EMOTI = { mp4: '06-how-cbd-can-help-with-emotional-trauma.mp4', vtt: '06-how-cbd-can-help-with-emotional-trauma.vtt', title: 'How CBD Can Help With Emotional Trauma'};
const HOW_SLEEP = { mp4: '07-how-cbd-can-help-with-sleep.mp4', vtt: '07-how-cbd-can-help-with-sleep.vtt', title: 'How CBD Can Help With Sleep'};
//const HOW_AUTIS = { mp4: '08-how-cbd-can-help-with-autism.mp4', vtt: '08-how-cbd-can-help-with-autism.vtt', title: 'How CBD Can Help With Autism'};
const HOW_HEADA = { mp4: '09-how-cbd-can-help-with-headaches.mp4', vtt: '09-how-cbd-can-help-with-headaches.vtt', title: 'How CBD Can Help With Headaches'};
const HOW_ACNE  = { mp4: '10-how-cbd-can-help-with-acne.mp4', vtt: '10-how-cbd-can-help-with-acne.vtt', title: 'How CBD Can Help With Acne'};
//const HOW_NEURO = { mp4: '11-how-cbd-can-help-with-neurological.mp4', vtt: '11-how-cbd-can-help-with-neurological.vtt', title: 'How CBD Can Help With Neurological'};
//const HOW_DISEA = { mp4: '12-how-cbd-can-help-with-disease.mp4', vtt: '12-how-cbd-can-help-with-disease.vtt', title: 'How CBD Can Help With Disease'};
//const HOW_HORMO = { mp4: '13-how-cbd-can-help-with-hormonal.mp4', vtt: '13-how-cbd-can-help-with-hormonal.vtt', title: 'How CBD Can Help With Hormonal'};
const WHAT_IS   = { mp4: '14-what-is-cbd.mp4', vtt: '14-what-is-cbd.vtt', title: 'What Is CBD?'};
const THREE_TYP = { mp4: '15-the-three-types-of-cbd.mp4', vtt: '15-the-three-types-of-cbd.vtt', title: 'The Three Types of CBD'};
const HISTORY   = { mp4: '16-what-is-the-history-of-cbd.mp4', vtt: '16-what-is-the-history-of-cbd.vtt', title: 'What Is The History Of CBD'};
//const OWN_STORE = { mp4: '17-own-a-cbd-advantage-store.mp4', vtt: '17-own-a-cbd-advantage-store.vtt', title: 'Own A CBD Advantage Store'};
//const WHY_START = { mp4: '18-why-i-started-cbd-advantage.mp4', vtt: '18-why-i-started-cbd-advantage.vtt', title: 'Why I Started CBD Advantage'};
const AND_PAIN  = { mp4: '19-cbd-and-pain-relief.mp4', vtt: '19-cbd-and-pain-relief.vtt', title: 'CBD And Pain Relief'};
const AND_SLEEP = { mp4: '20-cbd-and-sleep.mp4', vtt: '20-cbd-and-sleep.vtt', title: 'CBD And Sleep'};
const AND_FITNE = { mp4: '21-cbd-and-fitness.mp4', vtt: '21-cbd-and-fitness.vtt', title: 'CBD And Fitness'};
const AND_ANXIE = { mp4: '22-cbd-and-anxiety.mp4', vtt: '22-cbd-and-anxiety.vtt', title: 'CBD And Anxiety'};
const AND_PETS  = { mp4: '23-cbd-and-pets.mp4', vtt: '23-cbd-and-pets.vtt', title: 'CBD And Pets'};
const IS_LEGAL  = { mp4: '24-is-cbd-legal.mp4', vtt: '24-is-cbd-legal.vtt', title: 'Is CBD Legal?'};
const AND_SKIN  = { mp4: '25-cbd-and-skincare.mp4', vtt: '25-cbd-and-skincare.vtt', title: 'CBD And Skin Care'};
const CAN_ENERG = { mp4: '26-can-cbd-increase-energy.mp4', vtt: '26-can-cbd-increase-energy.vtt', title: 'Can CBD Increase Energy?'};

//const NON_EXIST = { mp4: '00-non-exist.mp4', vtt: null, title: 'Non-existant test file path. Will serve a 404.'};


export default class ProductDatabase implements IProductDatabase {

  private whitelabelPath: string;

  private productClassList: IProductClass[] = [
    PC_DROPS, PC_GUMMY, PC_SALVE, PC_CAPSL
  ];

  private productList: IProductBase[] = [
//    P_SALVE, P_GUMMIES, P_SOFTGEL, P_OILDROP, P_BATHBOM, P_FACESER, P_FACETON, P_FACECLE, P_HEMPEXT, P_BATHSOA, P_OILCARE, P_ISOLATE, P_FREEZE
    P_DROP300, P_DRP1000, P_GUMMIES, P_GMYSMPL, P_SALV150, P_SALV500, P_CAPSL15, P_CAPSL50
  ];
  private videoList: VideoFile[] = [
    // HOW_JOINT, HOW_ANXIE, HOW_DEPRE, HOW_PAIN, HOW_FOCUS, HOW_EMOTI, HOW_SLEEP, HOW_AUTIS, HOW_HEADA, HOW_ACNE, HOW_NEURO, HOW_DISEA, HOW_HORMO,
    // WHAT_IS, THREE_TYP, HISTORY, OWN_STORE, WHY_START, AND_PAIN, AND_SLEEP, AND_FITNE, AND_ANXIE, AND_PETS, IS_LEGAL, AND_SKIN, CAN_ENERG

    HOW_JOINT, HOW_ANXIE, HOW_PAIN, HOW_FOCUS, HOW_SLEEP, HOW_HEADA, HOW_ACNE,
    WHAT_IS, THREE_TYP, HISTORY,
    AND_PAIN, AND_SLEEP, AND_FITNE, AND_ANXIE, AND_PETS, IS_LEGAL, AND_SKIN, CAN_ENERG
  ];
  private topics: ITopicBase[] = [
    {
      id: 'sleep',
      name: 'Sleep',
      title: 'CBD and Sleep',
      description:
        'CBD seems to help with sleep through its anti-anxiety properties and its ability to help one relax. It has shown to affect ' +
        'the sleep/wake cycle. Please watch the videos and explore CBD Advantage\'s suggestions. Please watch the video',
      videos: [ AND_SLEEP, HOW_SLEEP ],
      products: [ P_DROP300, P_DRP1000, P_GUMMIES, P_CAPSL15, P_CAPSL50 ],
    },
    {
      id: 'inflammation',
      name: 'Inflammation',
      title: 'CBD and Inflammation',
      description:
        'Research has shown that cannabinoids, including CBD, could be a very effective systemic anti-inflammatory, helping many with ' +
        'nervous tissue, bowel, vascular, joint and other inflammation. Please watch the video to see which products we feel may ' +
        'best benefit you.',
      videos: [ HOW_JOINT, AND_PAIN, HOW_PAIN ],
      products: [ P_DROP300, P_DRP1000, P_SALV150, P_SALV500, P_CAPSL15, P_CAPSL50 ],
    },
    {
      id: 'anxiety',
      name: 'Anxiety',
      title: 'CBD and Anxiety',
      description:
        'CBD is believed to react with the CB1 receptors in the brain. Research is still exploring the extent of those effects. Studies ' +
        'suggest that it may alter serotonin signals. Serotonin is a neurotransmitter that plays a vital role in mental health. It is ' +
        'believed that low levels of serotonin in individuals can be associated with stress and anxiety. CBD is a potential natural ' +
        'alternative to help with anxiety and stress. Please watch the video and see which products we feel may best benefit you.',
      videos: [ AND_ANXIE, HOW_ANXIE ],
      products: [ P_DROP300, P_DRP1000, P_SALV500, P_CAPSL15, P_CAPSL50 ],
    },
    {
      id: 'focus',
      name: 'Focus',
      title: 'CBD and Focus',
      description:
        'CBD Advantage has several stories about how CBD has helped people focus at work, school and other times during the day. We have ' +
        'worked with several families who have explained various levels of lack of focus. Please watch the video to see which products we ' +
        'feel may best benefit you.',
      videos: [ HOW_FOCUS ],
      products: [ P_DROP300, P_DRP1000, P_SALV500, P_CAPSL15, P_CAPSL50 ],
    },
    {
      id: 'pain',
      name: 'Pain',
      title: 'CBD and Pain',
      description:
        'Some research suggests that CBD interacts with the ECS. (endocannabinoid receptors in your brain and immune system). CBD has ' +
        'shown to bind with the TRPV1 receptors, which also are ion channels. TRPV1 is known to mediate pain perception, inflammation, ' +
        'and body regulation. Please watch the video to see which products we feel may best benefit you.',
      videos: [ AND_PAIN, HOW_PAIN, HOW_HEADA ],
      products: [ P_DROP300, P_DRP1000, P_SALV150, P_SALV500, P_CAPSL15, P_CAPSL50 ],
    },
    {
      id: 'skin-care',
      name: 'Skin Care',
      title: 'CBD and Skin Care',
      description:
        'CBD has shown to have effects on the ph balance of skin. Studies have shown it to be have antifungal properties, and is helping ' +
        'with bacteria that cause breakouts. The anti-inflammatory components relax the skin and may reduce the appearance of wrinkles. ' +
        'Please watch the video to see which products we feel may best benefit you.',
      videos: [ AND_SKIN, HOW_ACNE ],
      products: [ P_DROP300, P_DRP1000, P_SALV150, P_SALV500, P_CAPSL15, P_CAPSL50 ],
    },
    {
      id: 'pets',
      name: 'Pets',
      title: 'CBD and Pets',
      description:
        'CBD has shown positive results with pets dealing with epilepsy, anxiety, irritable bowel disease, and chronic pain.',
      videos: [ AND_PETS ],
      products: [ P_DROP300, P_DRP1000, P_SALV500, P_CAPSL15, P_CAPSL50 ],
    }
  ];

  constructor(whitelabelPath: string) {
    this.whitelabelPath = whitelabelPath;
  }

  public getWhitelabelPath(): string {
    return this.whitelabelPath;
  }

  public getAllVideoFiles(): VideoFile[] {
    return this.videoList;
  }

  public getFrontPageVideoFiles(): VideoFile[] {
    return [
      WHAT_IS, THREE_TYP, HISTORY, AND_PAIN, AND_SLEEP, AND_FITNE, AND_ANXIE, AND_PETS, IS_LEGAL, AND_SKIN, CAN_ENERG
    ];
  }

  public getTopicById(topicId: string): ITopic {
    const topic = _.find(this.topics, (t) => topicId === t.id);
    return topic ? this.constructTopic(topic) : this.constructTopic(this.topics[0]);
  }

  public getAllProducts(): IProduct[] {
    return _.map<IProductBase, IProduct>(this.productList, (p) => this.toIProduct(p));
  }

  public getAllProductClasses(): IProductClass[] {
    return this.productClassList;
  }

  public getProductById(productId: number): IProduct | undefined {
    const product = _.find(this.productList, (p) => 0 === (p.id - productId));
    return product ? this.toIProduct(product) : undefined;
  }

  public getAllTopics(): ITopic[] {
    return _.map<ITopicBase, ITopic>(this.topics, (topic) => this.constructTopic(topic));
  }

  private constructTopic(topic: ITopicBase): ITopic {
    return {
      id: topic.id,
      name: topic.name,
      title: topic.title,
      description: topic.description,
      videos: topic.videos,
      products: _.map<IProductBase, IProduct>(topic.products, (p) => this.toIProduct(p)),
    };
  }

  private toIProduct(product: IProductBase): IProduct {
    const topicIds = this.getTopicIdsHavingProduct(product.name);
    return {
      ...product,
      rating: 8 + ((product.id * 11) % 3),
      topicIds,
    };
  }

  private getTopicIdsHavingProduct(productName: string): string[] {
    return _.map(
      _.filter(this.topics, (topic) => {
        return -1 < _.findIndex(topic.products, (p) => p.name === productName);
      }),
      (topic) => topic.id
    );
  }

}

